<div
  class="search-row"
  [attr.aria-label]="'Ver ' + product().name"
  (mousedown)="onSelect($event)"
>
  <img
    class="search-row__thumb"
    [src]="imageUrl()"
    [alt]="product().name"
    loading="lazy"
    decoding="async"
    width="48"
    height="64"
    (error)="onImgError($event)"
  />

  <span class="search-row__info">
    <span class="search-row__name">
      @for (seg of nameSegments(); track $index) {
        @if (seg.match) {
          <mark class="search-row__mark">{{ seg.text }}</mark>
        } @else {
          <span>{{ seg.text }}</span>
        }
      }
    </span>

    <span class="search-row__meta">
      @if (isSingle()) {
        <app-variant-badge [variant]="variant()">{{ variantLabel() }}</app-variant-badge>
      }
      @if (rarity(); as r) {
        <span class="search-row__rarity">{{ r }}</span>
      }
    </span>
  </span>

  @if (!isOutOfStock()) {
    <span class="search-row__prices">
      @if (product().isOnSale && product().originalPrice != null) {
        <span class="search-row__original-price">{{ originalPriceLabel() }}</span>
      }
      <span
        class="search-row__price"
        [class.search-row__price--sale]="product().isOnSale"
      >{{ priceLabel() }}</span>
    </span>
  }

  @if (canQuickAdd()) {
    <button
      type="button"
      class="search-row__quick-add"
      [attr.aria-label]="'Agregar ' + product().name + ' al carrito'"
      (mousedown)="onQuickAdd($event)"
    >
      <app-icon [icon]="plusIcon" [size]="14" color="currentColor" />
      <span>Agregar</span>
    </button>
  } @else if (canNotify()) {
    <button
      type="button"
      class="search-row__notify"
      [class.search-row__notify--active]="isNotifyActive()"
      [attr.aria-label]="(isNotifyActive() ? 'Ya no me avises sobre ' : 'Avisarme cuando haya stock de ') + product().name"
      [attr.aria-pressed]="isNotifyActive()"
      (mousedown)="onNotifyClick($event)"
      (keydown)="onNotifyKeydown($event)"
    >
      @if (isNotifyActive()) {
        <app-icon [icon]="bellOffIcon" [size]="14" color="currentColor" />
        <span>Ya no me avises</span>
      } @else {
        <app-icon [icon]="bellIcon" [size]="14" color="currentColor" />
        <span>Avisarme</span>
      }
    </button>
  } @else {
    <span class="search-row__unavailable" aria-hidden="true">Agotado</span>
  }
</div>
